module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAQ0lEQVQokWP8//8/Aw5whIGBASRpi00an0aYBCM2SSZcugiBIabxMDQg0DFyIKHjw+T6kXE0OvAAFjxyR3HKMDAwAABGCRlVD/9huAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/set_img.png
// module id = tdRY
// module chunks = 1